"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesService = void 0;
const Locator_service_1 = require("./Locator.service");
const common_model_1 = require("./common.model");
class AgenciesService {
    constructor() {
        this._locatorService = new Locator_service_1.LocatorService();
    }
    getAgencies(inputFilter, idSessione) {
        return this._locatorService
            .getAgencies(idSessione)
            .then((response) => {
            return this.mapResponse2Agencies2(inputFilter, response);
        })
            .catch((error) => this.handleAgenciesServiceError(error));
    }
    mapResponse2Agencies2(inputFilter, response, agenciesCodes) {
        let listAgenciesWrapper = null;
        let agency = null;
        const arrayAgency = [];
        let retVal = null;
        let myAgenciesCodes = [];
        if (agenciesCodes != null) {
            myAgenciesCodes = JSON.parse(agenciesCodes).agenciesCodes.map((code) => code.toString());
        }
        try {
            const agenciesResponse = response;
            if (agenciesResponse && agenciesResponse.poi) {
                listAgenciesWrapper = new common_model_1.ListAgencies();
                for (let i = 0; i < agenciesResponse.poi.length; i++) {
                    agency = this.mapResponse2Agency2(agenciesResponse.poi[i], myAgenciesCodes, inputFilter.categoryAgency);
                    arrayAgency.push(agency);
                }
                listAgenciesWrapper.listAgencies = arrayAgency;
                let codeMessage;
                let message = "";
                if (agenciesResponse.operationResult == null ||
                    agenciesResponse.operationResult.type == "0") {
                    codeMessage = "0";
                    if (agenciesResponse.operationResult != null) {
                        message = agenciesResponse.operationResult.message;
                    }
                }
                else {
                    codeMessage = "-1";
                    message = "ERROR DURING SERVICE AGENCIES!";
                }
                retVal = new common_model_1.ResponseAgencies(codeMessage, message);
                retVal.setResponseObject(listAgenciesWrapper);
            }
        }
        catch (error) {
            console.log("Error during mapResponse2Agencies");
            retVal = null;
        }
        return retVal;
    }
    handleAgenciesServiceError(error) {
        const respAgencies = new common_model_1.ResponseAgencies("-1", "ERROR DURING SERVICE AGENCIES!"); // Error response
        respAgencies.setResponseObject(null);
        return Promise.resolve(respAgencies);
    }
    mapResponse2Agency2(poi, myAgenciesCodes, categoryAgency) {
        var _a, _b;
        const agency = new common_model_1.Agency();
        // if (myAgenciesCodes.indexOf(poi.codice) != -1) {
        agency.isMyAgency = true;
        // }
        agency.code = poi.code;
        // switch (categoryAgency) {
        // case "AGENZIA":
        agency.code_ext = `Agenzia ${poi.code}`;
        if (poi.management) {
            agency.name = `- Agenzia di ${poi.management}`;
        }
        // break;
        agency.town = poi.town;
        agency.cip = poi.cip;
        agency.zipCode = poi.zipCode;
        agency.address = poi.address;
        agency.latitude = poi.latitude;
        agency.longitude = poi.longitude;
        agency.distance = poi.distance;
        agency.phoneNumber = poi.phoneNumber;
        agency.faxNumber = poi.faxNumber;
        agency.patronalFeast = poi.patronalFeast;
        agency.mail = poi.email;
        const openings = this.calculateOpenings(poi);
        agency.reduced = openings.reduced;
        agency.reducedFrom = openings.reducedFrom;
        agency.reducedTo = openings.reducedTo;
        agency.openingTime = openings.openingTime;
        agency.thereAreTimes = openings.thereAreTimes;
        if (categoryAgency === "LIQ") {
            agency.reducedPhone = openings.reducedPhone;
            agency.reducedFromPhone = openings.reducedFromPhone;
            agency.reducedToPhone = openings.reducedToPhone;
            agency.openingTimePhone = openings.openingTimePhone;
            agency.thereAreTimesPhone = openings.thereAreTimesPhone;
            (_a = agency.openingTime) === null || _a === void 0 ? void 0 : _a.forEach((ot) => {
                if (ot.morning === "CHIUSO" && ot.evening === "CHIUSO") {
                    ot.dayValidation = false;
                }
            });
            (_b = agency.openingTimePhone) === null || _b === void 0 ? void 0 : _b.forEach((ot) => {
                if (ot.morning === "CHIUSO" && ot.evening === "CHIUSO") {
                    ot.dayValidation = false;
                }
            });
        }
        return agency;
    }
    calculateOpenings(poi) {
        const openings = {
            reduced: false,
            reducedFrom: "",
            reducedTo: "",
            openingTime: [],
            reducedPhone: false,
            reducedFromPhone: "",
            reducedToPhone: "",
            openingTimePhone: [],
            thereAreTimes: false,
            thereAreTimesPhone: false,
        };
        let ot;
        if (poi.openingTime && poi.openingTime.length > 0) {
            ot = this.calculateOpeningTimes(poi.openingTime);
            openings.reduced = ot.reduced;
            openings.reducedFrom = ot.reducedFrom;
            openings.reducedTo = ot.reducedTo;
            openings.openingTime = ot.openingTime;
            openings.thereAreTimes = ot.thereAreTimes;
        }
        if (poi.orarioTel && poi.orarioTel.length > 0) {
            try {
                ot = this.calculateOpeningTimes(poi.orarioTel);
                openings.reducedPhone = ot.reduced;
                openings.reducedFromPhone = ot.reducedFrom;
                openings.reducedToPhone = ot.reducedTo;
                openings.openingTimePhone = ot.openingTime;
                openings.thereAreTimesPhone = ot.thereAreTimes;
            }
            catch (err) {
                console.log("Errore durante la formattazione degli orari telefonici");
            }
        }
        return openings;
    }
    calculateOpeningTimes(openTimeString) {
        var _a;
        const openTime = {
            openingTime: [],
            reduced: false,
            reducedFrom: "",
            reducedTo: "",
            thereAreTimes: false,
        };
        let openTimeDay;
        const weekDay = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
        // splitto la stringa con il | e ripulisco l'ultima posizione dell'array che rimane vuota
        const hours = openTimeString.split("|");
        hours.pop();
        // tolgo le prime due posizioni dell'array che vanno a indicare orari speciali e le inserisco nei dettagli di agenzia
        const fromTo = hours.splice(0, 2);
        if (fromTo[0] !== "" || fromTo[1] !== "") {
            openTime.reduced = true;
            openTime.reducedFrom = fromTo[0];
            openTime.reducedTo = fromTo[1];
        }
        // divido l'array in modo da avere 6 posizioni con i 4 orari di apertura e chiusura per giorno della settimana
        const hPerDay = [];
        const size = 4;
        while (hours.length > 0) {
            hPerDay.push(hours.splice(0, size));
        }
        // creo i 7 giorni della settimana con gli orari e li inserisco nei dettagli di agenzia
        for (let f = 0; f < 6; f++) {
            openTimeDay = new common_model_1.OpeningTime();
            openTimeDay.day = weekDay[f];
            hPerDay[f][0] !== hPerDay[f][1]
                ? (openTimeDay.morning = `${hPerDay[f][0]} - ${hPerDay[f][1]}`)
                : (openTimeDay.morning = hPerDay[f][0]);
            hPerDay[f][2] !== hPerDay[f][3]
                ? (openTimeDay.evening = `${hPerDay[f][2]} - ${hPerDay[f][3]}`)
                : (openTimeDay.evening = hPerDay[f][2]);
            openTimeDay.dayValidation = true;
            if (openTimeDay.morning == "" && openTimeDay.evening == "") {
                openTimeDay.dayValidation = false;
            }
            else {
                openTime.thereAreTimes = true;
            }
            (_a = openTime.openingTime) === null || _a === void 0 ? void 0 : _a.push(openTimeDay);
        }
        return openTime;
    }
}
exports.AgenciesService = AgenciesService;
